module.exports = (app) => app.factory('orderConfirmationService', /* @ngInject */ function (apiConfig, httpService) {

    function findAllForOrder(orderNumber) {
        const uri = apiConfig.getBase('order-confirmations');
        uri.query = {orderId: orderNumber};

        return httpService.get(uri.toString(), {isArray: true});
    }

    return {
        findAllForOrder,
    }
});